import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MagazinePageComponent } from '@app/magazine/magazine-page/magazine-page.component';
import { MagazineNewsComponent } from '@app/magazine/magazine-news/magazine-news.component';
import { MagazineEventsComponent } from '@app/magazine/magazine-events/magazine-events.component';
import { EventDetailPageComponent } from '@app/events/event-detail-page/event-detail-page.component';
import { NewsDetailPageComponent } from '@app/news/news-detail-page/news-detail-page.component';

const routes: Routes = [
  {
    path: '', component: MagazinePageComponent, children: [
      { path: '', redirectTo: 'news' },
      { path: 'news', component: MagazineNewsComponent },
      { path: 'events', component: MagazineEventsComponent }
    ]
  },
  { path: 'events/:slug', component: EventDetailPageComponent },
  { path: 'news/:slug', component: NewsDetailPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MagazineRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/magazine/magazine-routing.module.ts